import constant from "./mapconstants";

/** Returns the SET_MAP_DRAW event key, scoped by mapId when provided (e.g. 'dispatchMap_setMapDraw' or 'setMapDraw'). */
export function getSetMapDrawEventKey(mapId) {
  return mapId ? `${mapId}_${constant.EVENT.SET_MAP_DRAW}` : constant.EVENT.SET_MAP_DRAW;
}
